<template>
    <section>
        <Header />
        <template v-if="!loading">
            <div v-if="isPaidUser" class="create-workspace">
                <b-field label="Name">
                    <b-input v-model="name" maxlength="30" required></b-input>
                </b-field>
                <b-button type="is-primary" @click="_createWorkspace()">Create workspace</b-button>
            </div>
            <div v-else class="subscribe-section container">
                <section id="pricing">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pricing-box">
                        <div class="pricing-content">
                            <p style="font-size: 36px; font-weight: 300; line-height: 1.2;">One simple plan and you get Bugfer.</p>
                            <ul class="pricing-benefits">
                                <li>Free 14-day trial</li>
                                <li>Cancel anytime</li>
                                <li>Simple and easy to use platform</li>
                                <li>Open API, use your data</li>
                                <li>Integrations (Slack, Email, Asana, Github, etc...)</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pricing-box">
                        <div class="bgorange price" style="    background-color: #f87c45;">
                            <div class="amount">$29</div>
                            <div class="duration">monthly</div>
                        </div>
                        <div class="featcontent">
                            <div class="feat-list">
                                <ul>
                                    <li>Unlimited Projects</li>
                                    <li>Unlimited Users</li>
                                    <li>Email Issue Reporting</li>
                                </ul>
                            </div>
                            <div class="text-center">
                                <b-button type="is-success" @click="openPaddle()">Start your FREE trial</b-button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </template>
        <template v-else>
            <img src="/img/loading.gif" style="display: block; margin: 60px auto;">
        </template>
    </section>
</template>

<script>
import {getJWT, getHeaders} from '../logic/global'
import {createWorkspace} from '../logic/workspace'
import {getUserPlan, createLog, updateUser, getUser} from '../logic/account'
import Header from '../components/Header'
import jwt_decode from 'jwt-decode'

let name = ""
let isPaidUser = false
let loading = true
let country = ""
let postalcode = ""

export default {
    name: 'CreateWorkspace',
    components: {Header},
    data() {
        return {
            name: name,
            isPaidUser: isPaidUser,
            loading: loading,
            postalcode: postalcode,
            country: country,
        }
    },
    methods: {
        _createWorkspace: function(){
            createWorkspace({"name": this.name}).then(response => {
                this.showSuccessMsg("Workspace created successfully", "is-success")
                this.$router.push({name: 'workspaces'})
            }).catch(error => {
                this.showSuccessMsg(
                    "Error creating the workspace, try again later or contact support.",
                    "is-danger"
                )
            });
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
        openPaddle: function(){
            let _this = this;
            let token = jwt_decode(getJWT());
            Paddle.Checkout.open({
                product: 571576,
                email: token["email"],
                marketingConsent: true,
                successCallback: function(data) {
                    if(data.checkout.completed){
                        updateUser(token["id"], {"plan": 571576}).then(response => {
                            _this.isPaidUser = true
                        }).catch(error => {
                            _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                            createLog({"entity": token["id"], "title": "Error updating user after payment", "content": JSON.stringify(error)})
                        })
                    }else{
                        createLog({"entity": token["id"], "title": "Payment error", "content": data})
                    }
                }
            })
        },
    },
    mounted: function(){
        let token = jwt_decode(getJWT());
        let user_id = token["id"]
        let _this = this

        getUserPlan(user_id).then(response => {
            getUser(user_id).then(response => {
                _this.country = response.data.country
                _this.postalcode = response.data.postalcode
            })
            _this.isPaidUser = response.data.success
            _this.loading = false;
            if(!_this.isPaidUser){
                Paddle.Setup({vendor: 102272});
            }
        }).catch(error => {
            _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
        });
    }
}
</script>

<style scoped>
    .subscribe-section{
        margin: 50px auto;
        padding: 45px 35px;
        background: #fff;
    }
    .create-workspace{
        width: 450px;
        margin: 55px auto;
        text-align: center;
        padding: 40px;
        background: #fff;
    }
    .create-workspace >>> .label{
        font-weight: 200;
    }
    .create-workspace >>> .button{
        margin-top: 15px;
    }
    .pricing-benefits{
        margin-top: 30px;
        font-size: 20px;
        font-weight: 300;
        line-height: 2;
        padding-left: 40px;
        list-style-type: disc;
    }
    .pricing-features li{
        margin: 10px 0px;
        font-size: 20px;
        font-weight: 300;
    }
    #pricing
{
}

.pricing
{
	padding:50px 0 70px 0;
}

	.pricing h1
	{
		font-size:40px;
		color:#f87c45;
		font-weight:900;
		text-align:center;
	}
	
	.pricing h2
	{
		color:#000;
		font-size:30px;
		text-align:center;
		margin:0px;
	}


.pricing-box
{
}
	.pricing-box .price
	{
		color:#fff;
		text-align:center;
		padding:50px 0;
	}
	
		.pricing-box .price .package
		{
			font-size:30px;
			font-weight:bold;
			
			
		}
		
		.pricing-box .price .divider
		{
			height:2px;
			background:rgba(255,255,255,.3);
			width:40px;
			margin:20px auto;
		}
		
		.pricing-box .price .amount
		{
			font-size:50px;
			font-weight:300;
			line-height:50px;
			
		}
		
		.pricing-box .price .duration
		{
			font-size:20px;
			font-weight:300;
			padding-top:10px;
		}
	
	.pricing-box .featcontent
	{
		background:#f4f5f6;
	}
	
		.pricing-box .featcontent .feat-list
		{
			font-size:20px;
			font-weight:300;
			color:#656667;
		}
		
			.pricing-box .featcontent .feat-list ul
			{
				list-style:none;
				margin:0px;
				padding:0px;
				margin-bottom:15px;
			}

            .pricing-box .featcontent >>> .button{
                margin-bottom: 15px;
            }
			
			.pricing-box .featcontent .feat-list li
			{
				line-height:50px;
				border-bottom:1px solid rgba(0,0,0,0.1);
				padding:0 30px;
                font-size: 14px;
			}
			
			.pricing-box .featcontent .feat-list li:last-child
			{
				border-bottom:none;
			}
		
		.pricing-box .featcontent .signup-btn
		{
			font-size:	20px;
			text-align:center;
			padding-bottom:40px;
			
		}
		
				.pricing-box .featcontent .signup-btn a
				{
					padding:15px 30px;
					background:#424a56;
					color:#fff !important;
					text-decoration:none;
					transition:ease-in-out;
					transition-duration:.3s;
				}

				.pricing-box .featcontent .signup-btn a:hover
				{

					background:#f87c45;
					color:#fff !important;
					text-decoration:none;
				}		
</style>
